export function extractApiErrorMessage(error) {
    if (typeof error === "string") {
        return error;
    }
    if (error?.response?.data?.error?.message) {
        return error.response.data.error.message;
    }
    if (error instanceof Error) {
        return error.message;
    }
    return undefined;
}
